import React from 'react';
import Navigation from '../components/Navigation';
import { FooterSection } from '../components/ui/footer-section';
import Hero from '../components/landing/Hero';
import TheGap from '../components/landing/TheGap';
import FounderStory from '../components/landing/FounderStory';
import MentorSection from '../components/landing/MentorSection';
import AdvancedLabs from '../components/landing/AdvancedLabs';
import DailySignals from '../components/landing/DailySignals';
import FoodSection from '../components/landing/FoodSection';
import StonAI from '../components/landing/StonAI';
import StrengthSection from '../components/landing/StrengthSection';
import StonRoom from '../components/landing/StonRoom';
import ProfessionalsSection from '../components/landing/ProfessionalsSection';
import ConsoleShowcase from '../components/landing/ConsoleShowcase';
import FreeTools from '../components/landing/FreeTools';
import ProofSection from '../components/landing/ProofSection';
import FAQSection from '../components/landing/FAQSection';
import WaitlistCTA from '../components/landing/WaitlistCTA';

/**
 * Narrative order — tension, trust, proof, breadth, ask:
 *  Hero — the claim · Gap — the problem · Origin — trust · Mentor — authority
 *  01 READ · 02 TRACK · 03 FUEL · 04 SPEAK · 05 PROVE · 06 COMPETE
 *  07 GUIDE · Console · Tools · Get the app
 */
const LandingPage = () => {
  return (
    <div className="min-h-screen bg-ston-bg max-w-[100vw] overflow-x-clip">
      <Navigation />
      <Hero />
      <TheGap />
      <FounderStory />
      <MentorSection />
      <AdvancedLabs />
      <DailySignals />
      <FoodSection />
      <StonAI />
      <StrengthSection />
      <StonRoom />
      <ProfessionalsSection />
      <ConsoleShowcase />
      <FreeTools />
      <ProofSection />
      <FAQSection />
      <WaitlistCTA />
      <FooterSection />
    </div>
  );
};

export default LandingPage;
